
import React from 'react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';

interface CoachingNotificationsProps {
  hasExistingSession: boolean;
  isAuthenticated: boolean;
}

const CoachingNotifications = ({ hasExistingSession, isAuthenticated }: CoachingNotificationsProps) => {
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-md">
        <p className="text-sm text-yellow-800">
          <strong>Note:</strong> You'll need to sign in to complete your booking. 
          <Button 
            variant="link" 
            className="p-0 h-auto text-yellow-800 underline" 
            onClick={() => navigate('/login')}
          >
            Sign in now
          </Button>
        </p>
      </div>
    );
  }

  if (hasExistingSession) {
    return (
      <div className="bg-green-50 border border-green-200 p-4 rounded-md">
        <p className="text-sm text-green-800 font-medium">
          You already have a coaching session scheduled!
        </p>
        <p className="text-sm text-green-800 mt-1">
          View your session details on your profile page.
        </p>
        <Button 
          variant="outline" 
          className="mt-2 border-green-300 text-green-700 hover:bg-green-50" 
          onClick={() => navigate('/profile')}
        >
          View scheduled sessions
        </Button>
      </div>
    );
  }

  return null;
};

export default CoachingNotifications;
